<mat-progress-bar color="primary" [@progressFade] *ngIf="pageTeaserFacade.isLoading$ | async" mode="indeterminate"></mat-progress-bar>
<section class="page-top">
	<div class="container">
		<div class="intro">
			<div class="intro--bg"></div>
			<div class="intro--text">
				<h1 class="mat-h1">Verschenke ein Stück Zeit&shy;geschichte!</h1>
				<p>Schenke eine <strong>echte alte Zeitung</strong> vom Tag der Geburt oder Hochzeit.</p>
				<form>
					<shop-date-input [shouldTriggerSearch]="false"></shop-date-input>
					<button mat-flat-button color="accent" (click)="search()" routerLink="/suche">
						<mat-icon svgIcon="mdi-magnify"></mat-icon>
						Zeitungen finden
					</button>
				</form>
				<small class="intro--text__small text-center"><b>Original-Zeitung ab 39,90&thinsp;€</b> (Preis variiert nach Datum und Titel)</small>
			</div>
		</div>
	</div>
</section>

<ng-container *ngIf="pageFacade.selected$ | async as page">
	<shop-contentblocks [blocks]="page.blocks"></shop-contentblocks>
</ng-container>

<shop-howitworks></shop-howitworks>

<shop-usps></shop-usps>

<shop-calltoaction [parameters]="cta" [shouldTriggerSearch]="false"></shop-calltoaction>

<shop-customerreviews></shop-customerreviews>

<ng-container *ngIf="!(pageTeaserFacade.hasError$ | async)">
	<section class="page-teaser page-teaser--image-{{ i % 2 == 0 ? 'left' : 'right' }} container" *ngFor="let pageTeaser of pageTeaserFacade.list$ | async; let i = index">
		<figure class="page-teaser--image">
			<a [routerLink]="pageTeaser.button.url">
				<shop-picture [image]="pageTeaser.image" [width]="652" [height]="489"></shop-picture>
			</a>
		</figure>
		<div class="page-teaser--text">
			<h2 class="mat-h2">{{ pageTeaser.headline }}</h2>
			<div [innerHtml]="pageTeaser.text | safe"></div>
			<button mat-stroked-button color="primary" [routerLink]="pageTeaser.button.url" *ngIf="pageTeaser.button">{{ pageTeaser.button.caption }}</button>
		</div>
	</section>
</ng-container>
<ng-container *ngIf="pageTeaserFacade.hasError$ | async">
	<section class="container">
		<div class="alert alert--warning">
			<mat-icon svgIcon="mdi-alert-circle-outline" class="alert--icon"></mat-icon>
			<div class="alert--text">Page Teaser konnten nicht geladen werden: {{ pageTeaserFacade.error$ | async }}</div>
			<button mat-button class="alert--button" (click)="pageTeaserFacade.load()">Erneut versuchen</button>
		</div>
	</section>
</ng-container>
